<template>
  <div class="root">
    <linear-loader v-if="orderStatus === 1" text="Fetching Order Details..." />
    <template v-else-if="orderStatus === 2">
      <order-display :order="order" />

      <section>
        <linear-loader
          v-if="orderItemsStatus === 1"
          text="Fetching Order Items..."
        />
        <div v-else class="row hcenter">
          <!-- {{ orderItems[0] }} -->
          <div
            v-for="(item, i) in orderItems"
            :key="`order-item-${i}`"
            class="row vcenter pointer order-item"
            @click.prevent="gotoProduct(item.product)"
          >
            <div class="img order-item__img">
              <img
                :src="getProductImage(item.product)"
                :alt="`Primary image for ${item.product.name}`"
              />
            </div>
            <div class="order-item__info">
              <p class="mt-0 mb-0">{{ item.product.name }}</p>
              <p class="mt-1 mb-1">
                $ {{ getOrderItemPrice(item) }}
                for
                {{ item.quantity }} item{{ item.quantity > 1 ? "s" : "" }}
              </p>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { getProductPrimaryImage } from '@/utils';
import LinearLoader from "@/components/loaders/LinearLoader.vue";
import OrderDisplay from "./components/OrderDisplay.vue";

export default {
  name: "OrderDetails",
  components: {
    LinearLoader,
    OrderDisplay,
  },
  computed: {
    ...mapGetters({
      order: "Orders/order",
      orderStatus: "Orders/getOrderStatus",

      orderItems: "Orders/orderItems",
      orderItemsStatus: "Orders/getOrderItemsStatus",
    }),
  },
  created() {
    const orderId = this.$route.params.id;

    this.$store.dispatch("Orders/getOrder", orderId);
    this.$store.dispatch("Orders/getOrderItems", orderId);
  },
  methods: {
    getProductImage(product) {
      return getProductPrimaryImage(product)
    },
    getOrderItemPrice(orderItem) {
      const product = orderItem.product
      return orderItem.quantity * (product.price - product.discountPrice);
    },

    gotoProduct(product) {
      const id = product.id;
      this.$router.push({ name: "ProductDetails", params: { id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  width: 100%;
}
.order-item {
  margin-bottom: 1rem;

  &__img {
    width: 100%;
    padding: 0.75rem;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: linear-gradient(150deg, #ffffffda, #00000015);

    @include tablet-and-up {
      border-radius: 10px;
      max-width: 270px;
      min-width: 300px;
      min-height: 105px;
    }

    img {
      min-width: 250px;
      border-radius: 5px;
      box-shadow: 0 10px 20px 5px #00000025;
    }
  }

  &__info {
    flex: 1;
    padding: 1rem;
    background-color: #fffffff0;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    box-shadow: 2px 3px 10px 2px #00000005;

    @include tablet-and-up {
      height: max-content;
      margin-left: -1.5rem;
      border-radius: 10px;
      max-width: 500px;
      min-width: 400px;
    }

    @supports (backdrop-filter: blur()) {
      background-color: #ffffff50;
      backdrop-filter: blur(20px);
    }
  }

  @include laptop-and-up {
    width: max-content;
  }
}
</style>
<style lang="scss">
.theme-dark {
  .order-item {
    &__img {
      background: linear-gradient(150deg, #000000da, #ffffff15) !important;
    }
    &__info {
      background-color: $dark-light-color !important;
      box-shadow: 2px 3px 10px 2px #ffffff05 !important;
    }
  }
}
</style>